export default __webpack_public_path__ + "static/media/cart-white.ccc9ca54.svg";